import React, { FC } from 'react'
import { Facet } from '@ucheba/ui/components/Facet/desktop'
import { ESpecialitiesFacets } from '@ucheba/store/specialities/search/types'
import { EProfessionsSearchFacets } from '@ucheba/store/professions/search/types'
import { searchQueryByFacet, titleByFacetName } from '../constants'
import { ISpecialitiesSearchPageFacetsProps } from '../types'

const SpecialitiesSearchPageFacets: FC<ISpecialitiesSearchPageFacetsProps> = (props) => {
  const { facets, onSubmit, initialValues, isFriendlyUrlPage } = props

  const RadioAllRubric = (
    <Facet
      isRadio
      items={[
        {
          name: 'Все рубрики',
          value: '',
          count: 1,
        },
      ]}
      controlName={searchQueryByFacet[EProfessionsSearchFacets.tags]}
      onSubmit={onSubmit(EProfessionsSearchFacets.tags)}
      spacing='xsmall'
      initialValues={
        initialValues && initialValues[searchQueryByFacet[EProfessionsSearchFacets.tags]]
      }
      fillByQuery={!isFriendlyUrlPage}
    />
  )

  if (!facets) return null

  return (
    <>
      <Facet
        isRadio
        isForcedArray
        onSubmit={onSubmit(ESpecialitiesFacets.tags)}
        title={titleByFacetName[ESpecialitiesFacets.tags]}
        controlName={searchQueryByFacet[ESpecialitiesFacets.tags]}
        items={facets[ESpecialitiesFacets.tags]}
        initialValues={
          initialValues && initialValues[searchQueryByFacet[ESpecialitiesFacets.tags]]
        }
        fillByQuery={!isFriendlyUrlPage}
        afterTitleElement={RadioAllRubric}
      />

      <Facet
        onSubmit={onSubmit(ESpecialitiesFacets.trainingFormTypes)}
        title={titleByFacetName[ESpecialitiesFacets.trainingFormTypes]}
        controlName={searchQueryByFacet[ESpecialitiesFacets.trainingFormTypes]}
        items={facets[ESpecialitiesFacets.trainingFormTypes]}
        initialValues={
          initialValues &&
          initialValues[searchQueryByFacet[ESpecialitiesFacets.trainingFormTypes]]
        }
        fillByQuery={!isFriendlyUrlPage}
      />

      <Facet
        onSubmit={onSubmit(ESpecialitiesFacets.programTypes)}
        title={titleByFacetName[ESpecialitiesFacets.programTypes]}
        controlName={searchQueryByFacet[ESpecialitiesFacets.programTypes]}
        items={facets[ESpecialitiesFacets.programTypes]}
        initialValues={
          initialValues &&
          initialValues[searchQueryByFacet[ESpecialitiesFacets.programTypes]]
        }
        fillByQuery={!isFriendlyUrlPage}
      />

      <Facet
        onSubmit={onSubmit(ESpecialitiesFacets.examSubjects)}
        title={titleByFacetName[ESpecialitiesFacets.examSubjects]}
        controlName={searchQueryByFacet[ESpecialitiesFacets.examSubjects]}
        items={facets[ESpecialitiesFacets.examSubjects]}
        maxItems={8}
        initialValues={
          initialValues &&
          initialValues[searchQueryByFacet[ESpecialitiesFacets.examSubjects]]
        }
        fillByQuery={!isFriendlyUrlPage}
      />

      <Facet
        onSubmit={onSubmit(ESpecialitiesFacets.locations)}
        title={titleByFacetName[ESpecialitiesFacets.locations]}
        controlName={searchQueryByFacet[ESpecialitiesFacets.locations]}
        items={facets[ESpecialitiesFacets.locations]}
        maxItems={8}
        initialValues={
          initialValues &&
          initialValues[searchQueryByFacet[ESpecialitiesFacets.locations]]
        }
        fillByQuery={!isFriendlyUrlPage}
      />
    </>
  )
}

export default SpecialitiesSearchPageFacets
